<template>
  <el-container>
    <el-header>
      <xheader></xheader>
    </el-header>
    <el-main>
      <el-carousel height="650px">
        <el-carousel-item v-for="item in carouselImg" :key="item">
          <img :src="item" />
        </el-carousel-item>
      </el-carousel>
      <router-view />
    </el-main>
    <el-footer>
      <xfooter></xfooter>
    </el-footer>
  </el-container>
</template>

<script>
import xheader from "@/components/layout/xheader";
import xfooter from "@/components/layout/xfooter";
import banner1 from "@/assets/images/banner1.png";
import banner2 from "@/assets/images/banner2.png";
import banner3 from "@/assets/images/banner3.png";
export default {
  name: "Home",
  data() {
    return {
      carouselImg: [banner1, banner2, banner3],
    };
  },
  computed: {},
  watch: {
    $route(to, from) {},
  },
  components: {
    xheader,
    xfooter,
  },
  methods: {
    async pageList() {
      //查询宣传图列表
      // let access_token = sessionStorage.getItem("xcaccess_token");
      // let query = {
      //   access_token: access_token,
      // };
      // let obj = {
      //   fldl: this.form.fldl,
      //   flxl: this.form.flxl,
      //   jd: this.form.jd,
      //   wd: this.form.wd,
      //   nr: this.form.nr,
      //   xzqhzhen: this.userInfo.xzqhzhen,
      //   xzqhcun: this.userInfo.xzqhcun,
      //   xzqhdm: this.userInfo.xzqhdm,
      //   xzqhmc: this.userInfo.xzqhzhen + "," + this.userInfo.xzqhcun,
      // };
      // let res = await this.$http.pageList(query, obj);
      // if (res && res.errorNo == 1) {
      //   this.$message.success(res.response);
      //   this.dialogVisible = false;
      //   this.queryDzdtxx();
      // } else {
      //   this.$message.error(res.errorMsg);
      // }
    },
  },
  mounted() {
    this.pageList();
  },
};
</script>
<style lang="less" scoped>
.swiper-container {
  position: relative;
  width: 100%;
  height: 360px;
  .swiper-slide {
    color: #000;
    font-size: 16px;
    text-align: center;
    .his {
      cursor: pointer;
      .his_img {
        width: 230px;
        height: 300px;
      }
      .his_name {
        font-size: 16px;
        margin-top: 10px;
        text-align: center;
        color: #4b4b4b;
        cursor: pointer;
        &:hover {
          color: #fea004;
        }
      }
    }
  }
}
</style>